import { render } from "./MaSouscription.vue?vue&type=template&id=33880918&scoped=true&ts=true"
import script from "./MaSouscription.vue?vue&type=script&lang=ts"
export * from "./MaSouscription.vue?vue&type=script&lang=ts"

import "./MaSouscription.vue?vue&type=style&index=0&id=33880918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33880918"]])

export default __exports__